import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import AppBarNav from "./AppBar";

const ProtectedRoute = ({ redirectPath = "/login", children }) => {
  const { isLoggedIn, isInitializing } = useSelector(
    (state) => state.auth
  );

  if (isInitializing) {
    return null;
  }

  if (!isLoggedIn) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? (
    children
  ) : (
    <>
      <AppBarNav />
      <Outlet />
    </>
  );
};

export default ProtectedRoute;